import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CFormInput, CFormLabel, CFormTextarea } from '@coreui/react'

import React, { useEffect, useState } from 'react'
import { Plus } from 'lucide-react'
import CustomDatePickingFormat from './CustomDatePickingFormat'

const MorseBimsScore = ({ noteStructureRef, heading, showDataIfNoteIsFollowUp = true, showTreatmentAsAccordion, diagnosisName, scoreType, updateNoteStructure, type = 'note' }) => {
  const [score, setScore] = useState('')
  const [date, setDate] = useState('')

  const [visible, setVisible] = useState(false)
  const [modalScore, setModalScore] = useState('')
  const [modalDate, setModalDate] = useState('')

  useEffect(() => {
    const data = noteStructureRef.current?.[scoreType]?.[diagnosisName]
    if (data) {
      setModalScore(data.score || '')
      setModalDate(data.date || '')
      setScore(data.score || '')
      setDate(data.date || '')
    }
  }, [diagnosisName, scoreType])

  const openModal = () => {
    setModalScore(score || '')
    setModalDate(date || '')
    setVisible(true)
  }

  const handleModalSave = () => {
    setScore(modalScore)
    setDate(modalDate)
    updateNoteStructure(modalScore, modalDate, diagnosisName, scoreType)
    setVisible(false)
  }

  return (
    <>
      {heading && (
        <h6 style={{ fontSize: '14px' }}>
          <b>{heading}</b>
        </h6>
      )}

      <div className="d-flex justify-content-start align-items-center gap-5 ">
        {showTreatmentAsAccordion ? (
          date &&
          score && (
            <div className="d-flex">
              <div className="d-flex gap-2" style={{ minWidth: '100px' }}>
                <CFormLabel>
                  <strong>Score:</strong>
                </CFormLabel>
                <p>{score}</p>
              </div>
              <div className="d-flex gap-2">
                <CFormLabel>
                  <strong>Date:</strong>
                </CFormLabel>
                <p>{date ? new Date(date).toLocaleDateString('en-US') : '-'}</p>
              </div>
            </div>
          )
        ) : (
          <div className="mb-3 w-100">
            <div className="d-flex align-items-center gap-2">
              <h7>
                <b>BIMS Score </b>
              </h7>
              <CFormLabel
                className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
                onClick={() => setVisible((p) => !p)}
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '20px',
                  background: 'var(--ui-color-primary, #2b7cd3)',
                  cursor: 'pointer',
                }}
              >
                <Plus className="patient-note-action-icon" strokeWidth={2} size={15} />
              </CFormLabel>
            </div>
            <hr />
            <CFormTextarea
              disabled
              rows={2}
              value={score && date ? `BIMS Score: ${score}    Date: ${new Date(date).toLocaleDateString('en-US')}` : ''}
              style={{
                fontSize: '14px',
                backgroundColor: '#f8f9fa',
                border: 'none',
                color: '#495057',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
              }}
            />
          </div>
        )}
      </div>

      <CModal visible={visible} onClose={() => setVisible(false)} aria-labelledby="BimsScoreModal">
        <CModalHeader>
          <CModalTitle id="BimsScoreModal">BIMS Score</CModalTitle>
        </CModalHeader>
        <CModalBody className="flex-column gap-4 d-flex">
          <div className="d-flex flex-column w-50">
            <CFormLabel>Date</CFormLabel>
            <CustomDatePickingFormat value={modalDate} onChange={setModalDate} />
          </div>

          <div>
            <CFormLabel>Score</CFormLabel>
            <CFormInput type="text" placeholder="Enter Score" value={modalScore} onChange={(e) => setModalScore(e.target.value)} className="text-white" />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleModalSave}>
            Save
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default MorseBimsScore
